import { jsx } from '@emotion/react/jsx-runtime';
import { css } from '@emotion/react';
import { until, from } from '../../foundations/mq/mq.js';

const Hide = ({
  children,
  above,
  // deprecated
  below,
  // deprecated
  from: from$1 = above,
  until: until$1 = below
}) => {
  let whenToHide;
  if (until$1) {
    whenToHide = css`
			${until[until$1]} {
				display: none;
			}
		`;
  }
  if (from$1) {
    whenToHide = css`
			${whenToHide}
			${from[from$1]} {
				display: none;
			}
		`;
  }
  return /* @__PURE__ */ jsx("span", { css: whenToHide, children });
};

export { Hide };
